export default "//static.tradera.net/touchweb/static/output/images/qr-code-appstore.0582b091.svg";